import { render, staticRenderFns } from "./BaseInputText.vue?vue&type=template&id=257515e0"
import script from "./BaseInputText.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseInputText.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports